
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pronajem-uceben",
      function () {
        return require("private-next-pages/pronajem-uceben.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pronajem-uceben"])
      });
    }
  